import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface DataTablePaginationProps {
	page: number;
	pageSize: number;
	totalItems: number;
	onPageChange: (page: number) => void;
	nextButtonTestId?: string;
	prevButtonTestId?: string;
}

const DataTablePagination: React.FC<DataTablePaginationProps> = ({
	page,
	totalItems,
	pageSize,
	onPageChange,
	prevButtonTestId,
	nextButtonTestId,
}) => {
	const totalPages = Math.ceil(totalItems / pageSize);

	return (
		<div className="flex items-center gap-2">
			{/* Botão Voltar */}
			<button
				type="button"
				data-testid={prevButtonTestId}
				onClick={() => onPageChange(page - 1)}
				disabled={page === 1}
				className="flex h-8 w-8 items-center justify-center rounded-lg border border-solid border-stone-300 bg-white text-stone-500 outline-none transition-all hover:border-stone-500 hover:text-stone-800 disabled:cursor-not-allowed disabled:opacity-30 "
			>
				<ChevronLeft size={16} strokeWidth={3} />
			</button>

			{/* Indicador de Página Atual */}
			<div className="flex h-8 w-10 items-center justify-center rounded-lg border border-solid border-stone-300 bg-white text-[12px] font-bold text-stone-800">
				{page}
			</div>

			{/* Botão Avançar */}
			<button
				type="button"
				data-testid={nextButtonTestId}
				onClick={() => onPageChange(page + 1)}
				disabled={page === totalPages || totalPages === 0}
				className="flex h-8 w-8 items-center justify-center rounded-lg border border-solid border-stone-300 bg-white text-stone-500 outline-none transition-all hover:border-stone-500 hover:text-stone-800 disabled:cursor-not-allowed disabled:opacity-30 "
			>
				<ChevronRight size={16} strokeWidth={3} />
			</button>
		</div>
	);
};

export { DataTablePagination };
